// src/Admin/AdminRoute.jsx
import { Navigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { useEffect} from "react";
import { useDispatch, useSelector } from "react-redux";
import { getUser, logout } from "../Redux/Auth/Action";


const AdminRoute = ({ children }) => {
  const auth = useSelector((state) => state.auth.user);
  const jwt = localStorage.getItem("jwt");
 
    const dispatch = useDispatch();
    
   useEffect(() => {
      if (jwt) {
        dispatch(getUser(jwt));
        // dispatch(getCart(jwt));
      }
    }, []);

  try {


    // ✅ check role
    if (auth.role !== "ADMIN") {
       return <Navigate to="/admin" replace />;
      
    }
     return children;
  } catch (err) {
    console.error("Invalid token", err);
    localStorage.removeItem("name");
    return <Navigate to="/sign-in" replace />;
  }
    if (!auth) {
    return <Navigate to="/sign-in" replace />;
  }
};

export default AdminRoute;
